import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

/**
 * This hook uses a selector to get the "edit master data" menu item. It uses that menu item data
 * (which is provided by the back-end) to get the "edit master data" complex form. You can then use
 * this data to open an overlay with this form in it.
 *
 * Note: this hook does not take care of the fetching of the menu item or the edit master data form.
 * That should be handled separately. This just checks what's in the Redux state and returns it.
 */

const useEditMasterDataForm = () => {
  const { t } = useTranslation()

  const actionBarItems = useSelector((state) => state?.data?.actionBarItems)
  const menuItem = useSelector((state) =>
    state?.data?.actionBarItems?.data?.contextmenu?.find(
      (item) => item.id === 'gegevensAanpassen',
    ),
  )
  const title = menuItem?.label
  const icon = menuItem?.icon
  const category = menuItem?.overlay?.form_category || ''
  const id = menuItem?.overlay?.form_id || ''
  const backendSubmitText = menuItem?.overlay?.submit_text
  const formCategory = useSelector((state) => state?.forms?.[category])
  const form = formCategory?.data?.[id]

  // The submit button label is resolved with the following priority:
  // 1. `submit_text` from the backend overlay/complexform configuration
  // 2. A translation override via `overlaySubmitButtonTexts.{form_category}.{form_id}`
  // 3. The default 'saveChanges' translation ("Wijzigingen opslaan")
  let submitText = t('saveChanges')
  if (backendSubmitText) {
    submitText = backendSubmitText
  } else {
    const translationKey = `overlaySubmitButtonTexts.${category}.${id}`
    const translatedSubmitText = t(translationKey)
    if (translatedSubmitText !== translationKey) {
      submitText = translatedSubmitText
    }
  }

  const isLoading =
    !actionBarItems ||
    actionBarItems.loading ||
    !formCategory ||
    formCategory.loading

  return {
    title,
    icon,
    category,
    id,
    form,
    submitText,
    isLoading,
  }
}

export default useEditMasterDataForm
